import React from "react";

import logo from "../../assets/img/cined-logo.png";

import "./HomeMigration.css";

const TRANSITION_MODE = "moved"; // 'maintenance' or 'moved'
const NEW_WEBSITE_URL = "https://atlas-admin.cined.art";

export default function HomepageMigration() {

  return (
    <div className="homepage-container">
      <div className="app-background" />

      <div className="logoWrapper">
        <img src={logo} className="logo" alt="logo" />
        <div className="slogan">
          European Cinema
          <br />
          Education for Youth
        </div>
      </div>

      <div className="homepage-blocking-overlay">
        <div className="homepage-blocking-card">
          <img src={logo} alt="CinEd logo" className="homepage-blocking-logo" />

          <h1 className="homepage-blocking-title">
            {TRANSITION_MODE === "maintenance"
              ? "We’re moving to a new home"
              : "CinEd has moved"}
          </h1>

          <p className="homepage-blocking-text">
            {TRANSITION_MODE === "maintenance"
              ? "CinEd is temporarily unavailable while we move to a new home. We’ll be back very soon."
              : "This website is no longer maintained. Please use our new website:"}
          </p>

          {TRANSITION_MODE === "moved" && (
            <>
              <p>
                <a
                  className="homepage-blocking-url"
                  href={NEW_WEBSITE_URL}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  {NEW_WEBSITE_URL}
                </a>
              </p>

              <a
                className="homepage-blocking-button"
                href={NEW_WEBSITE_URL}
                target="_blank"
                rel="noopener noreferrer"
              >
                Go to new website
              </a>

              <p className="homepage-blocking-note">
                Please update your bookmarks.
              </p>
            </>
          )}
        </div>
      </div>
    </div>
  );
}
